<div class="carousel-container" [class.no-padding]="noSpace">
    <span *ngIf="controlPaginadorNormal || contentTable" class="carousel-control prev" (click)="previous()" [class.content-icon-carousel]="contentTable">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
    </span>
  
    <div class="carousel-content">
      <div class="carousel-item" *ngFor="let item of visibleItems; let i = index"  [ngStyle]="showShadow ? { 'box-shadow': 'rgba(153,153,153,0.15)' } : null" [class.no-margin]="noSpace">
        <div [class.carousel-header]="item.title" *ngIf="!contentTable">
          {{item.title}} 
          <div class="carousel-indicator" *ngIf="displayCount === 1 && !controlPaginadorNormal">
            <span class="carousel-control-header prev" (click)="previous()">
              <fa-icon [icon]="faChevronLeft"></fa-icon>
            </span>
            {{ currentStartIndex + 1 }}/{{ totalItems }}
            <span class="carousel-control-header next" (click)="next()">
              <fa-icon [icon]="faChevronRight"></fa-icon>
            </span>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="item.content"></ng-container>
      </div>
    </div>
  
    <span *ngIf="controlPaginadorNormal || contentTable" class="carousel-control next" (click)="next()" [class.content-icon-carousel]="contentTable">
        <fa-icon [icon]="faChevronRight"></fa-icon>
    </span>
  
    <div class="carousel-dots">
      <span  class="dot" *ngFor="let dot of dots; let i = index" [class.active]="isActiveDot(i)" (click)="goToSlide(i)">
      </span>
    </div>
  </div>
  